import React, { useEffect, useMemo, useState } from 'react'
import { getDatabase, ref, child, get } from "firebase/database";
import addContactRt from '../../../Firebase/firestore/addContact';
import { toast } from 'react-toastify';
import { filter, orderBy } from 'lodash'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import moment from 'moment'
import 'moment/locale/vi'
import { Form } from 'react-bootstrap';
import Pagination from '../../../components/Pagination';
moment.locale('vi')

function includes(a, b) {
    return a.toLowerCase().includes(b.toLowerCase())
    }
    function check(data, typing) {
        // console.log(book)
        return (
            includes(data.name || '', typing) ||
            includes(data.phone || '', typing) ||
            includes(data.email || '', typing) ||
            includes(data.note || '', typing)
        )
    }

function ContactList() {
    const [typing, setTyping] = useState('')
    const [items, setItems] = useState([])
    const [data, setData] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    
    useEffect(() => {
    const dbRef = ref(getDatabase());
    get(child(dbRef, `contacts`)).then((snapshot) => {
        if (snapshot.exists()) {
        const data = snapshot.val();
        setData(Object.values(data))
        } else {
        console.log("No data available");
        }
    }).catch((error) => {
        console.error(error);
    })
    },[])
    
    const handleUpdateContact = (item, e) => {
    const data = {
        id: item.id,
        name: item.name,
        phone: item.phone,
        email: item.email,
        note: item.note,
        date: item.date,
        status: e.target.value
    }

    addContactRt(data).then(() => {
        toast('Đã Liên Hệ Thành Công', { hideProgressBar: true, autoClose: 2000, type: 'success' })
    })
    .then(err => console.log(err))
    }

    useEffect(() => {
        if (data.length >= 1) {
            if (typing.length < 2 && data.length > 0) {
                setItems(data)
                setCurrentPage(1)
            }
            if (typing.length >= 2 && data.length > 0) {
                    const result = filter(data, tour => check(tour, typing))
                    setItems(orderBy(result))
                    setCurrentPage(1)
            }
        }
    }, [typing, data])


    let PageSize = 10

    const currentTableData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * PageSize
        const lastPageIndex = firstPageIndex + PageSize
        return items.slice(firstPageIndex, lastPageIndex)
    }, [currentPage, items])

    const onChangeClickPage = (page) => {
        setCurrentPage(page)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    return (
        <div className="page-content">
        <div className='d-flex mb-4'>
            <div className='mr-auto d-flex align-items-center'>
            <h5 className='mb-0'>Danh Sách Contact</h5>
            </div>
            <div className='d-flex'>
            <form className="app-search mr-3 d-none d-lg-block">
                <div className="position-relative">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Search Contact Name, Phone, Email..."
                    value={typing}
                    onChange={e => setTyping(e.target.value)}
                />
                <span className="bx bx-search-alt" />
                </div>
            </form>
            </div>
        </div>
        <Table className="table-list">
            <Thead>
            <Tr>
                <Th>Time</Th>
                <Th>Name</Th>
                <Th>Phone</Th>
                <Th>Email</Th>
                <Th>Note</Th>
                <Th>Trạng Thái</Th>
            </Tr>
            </Thead>
            <Tbody>
            {currentTableData.map((item, index) => {
                return <Tr key={index}>
                <Td>{moment(item.date).calendar()}</Td>
                <Td>{item.name}</Td>
                <Td>{item.phone}</Td>
                <Td>{item.email}</Td>
                <Td>{item.note}</Td>
                <Td><Form.Select defaultValue={item.status} onChange={(e) => handleUpdateContact(item, e)}>
                    <option value="da-xac-nhan">Đã Xác Nhận</option>
                    <option value="chua-xac-nhan">Chưa Xác Nhận</option>
                </Form.Select></Td>
                </Tr>
            })}
            </Tbody>
        </Table>
        <Pagination
            className='pagination-bar'
            currentPage={currentPage}
            totalCount={items.length}
            pageSize={PageSize}
            onPageChange={(page) => onChangeClickPage(page)}
        />
    </div>
    )
}

export default ContactList